import type { IconProps } from './types';
import './icons.css';

export default function Eye({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 14}
      height={height || 14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-eye ${className || ''}`}
    >
      <path
        d="M1.69721 7.68352C1.49796 7.25003 1.49796 6.74995 1.69721 6.31646C2.61952 4.30991 4.64718 2.91666 7.00025 2.91666C9.35332 2.91666 11.381 4.30991 12.3033 6.31647C12.5025 6.74995 12.5025 7.25004 12.3033 7.68352C11.381 9.69008 9.35332 11.0833 7.00025 11.0833C4.64718 11.0833 2.61952 9.69008 1.69721 7.68352Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M8.75025 6.99999C8.75025 7.96649 7.96675 8.74999 7.00025 8.74999C6.03375 8.74999 5.25025 7.96649 5.25025 6.99999C5.25025 6.03349 6.03375 5.24999 7.00025 5.24999C7.96675 5.24999 8.75025 6.03349 8.75025 6.99999Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
